'use client'

import { Box, Button, Group, Stack, Text } from '@mantine/core'
import Link from 'next/link'
import { useTranslations } from 'next-intl'

import { BASE_PATH } from '@/configs/const'

import errorStyles from '../error/styles.module.css'
import styles from './styles.module.css'

export default function PageNotFound() {
  const t = useTranslations('pageNotFound')

  return (
    <Stack flex={1} pt={40} pb={{ base: 40, medium: 160 }} h="100%" justify="stretch" mx="-sm">
      <Stack className={errorStyles.genericContent} pb={0} pt={{ base: 0, medium: 40 }}>
        <Text variant="story-text" c="var(--content-primary)">
          {t('title')}
        </Text>

        <Box h={360} />

        <Stack gap="md">
          <Text variant="heading2" c="var(--content-primary)">
            {t('subtitle')}
          </Text>
          {/* Action Buttons */}
          <Group gap="16px" align="center" justify="center" className={styles.buttonGroup}>
            <Button
              component="a"
              variant="filled-secondary"
              size="md"
              target="_blank"
              href="https://crypto.com"
              className={styles.button}
            >
              <Text variant="body-emphasis">{t('returnHome_1')}</Text>
            </Button>

            <Button
              href={`/en${BASE_PATH}`}
              size="md"
              component={Link}
              variant="filled-secondary"
              className={styles.button}
            >
              <Text variant="body-emphasis">{t('viewCryptoPrices')}</Text>
            </Button>
            <Button
              component="a"
              size="md"
              target="_blank"
              href="http://help.crypto.com"
              variant="filled-secondary"
              className={styles.button}
            >
              <Text variant="body-emphasis">{t('getSupport')}</Text>
            </Button>
          </Group>
        </Stack>
      </Stack>
    </Stack>
  )
}
